module.exports = __webpack_public_path__ + "static/object-3-ce6aa84929460b3e6c03f4c27029eafc.png";